"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.travelTo = exports.travelTowards = exports.requestTravelTo = exports.reveal = exports.clear = exports.addRandom = exports.travelToFirstStarbase = exports.generateStarmap = void 0;
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var voyageMissionData_1 = require("@voyage/missions/voyageMissionData");
var voyageMessageJump_1 = require("@voyage/multi/voyageMessageJump");
var voyageMessageJump_sidecar_1 = require("@voyage/multi/voyageMessageJump-sidecar");
var voyageStarmapLocationData_sidecar_1 = require("./voyageStarmapLocationData-sidecar");
var voyageStarmaps_sidecar_1 = require("./voyageStarmaps-sidecar");
var voyageStarmapTiles_sidecar_1 = require("./voyageStarmapTiles-sidecar");
function generateStarmap(seed) {
    var obj = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    clear();
    rando_sidecar_1.rando.setSeed(seed);
    obj.seed = seed;
    var locs = voyageStarmapLocationData_sidecar_1.voyageStarmapLocationData.generateStandardLocations();
    // if (seed === 0) {
    //   seed = rando.i(1, 32000)
    // }
    // let buffer = 3
    // let sx = rando.i(buffer, obj.width - buffer)
    // let sy = rando.fj(buffer, obj.height - buffer)
    imports_1.l.forEach(locs, function (c) {
        addRandom(obj, c);
    });
}
exports.generateStarmap = generateStarmap;
function travelToFirstStarbase() {
    var obj = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    for (var j = 0; j < obj.height; j++) {
        for (var i = 0; i < obj.width; i++) {
            var t = voyageStarmaps_sidecar_1.voyageStarmaps.getTileUnsafe(obj, i, j);
            if (t.location && t.location.mission === voyageMissionData_1.EVoyageMissionType.Starbase) {
                travelTo(i, j, true);
                return;
            }
        }
    }
    // This should not happen
    travelTo(5, 5, true);
}
exports.travelToFirstStarbase = travelToFirstStarbase;
function addRandom(obj, c) {
    for (var iAttempt = 0; iAttempt < 100; iAttempt++) {
        var i = rando_sidecar_1.rando.i(0, obj.width - 1);
        var j = rando_sidecar_1.rando.i(0, obj.height - 1);
        var t = voyageStarmaps_sidecar_1.voyageStarmaps.getTileUnsafe(obj, i, j);
        if (t.location) {
            continue;
        }
        voyageStarmapTiles_sidecar_1.voyageStarmapTiles.setLocation(t, c);
        return true;
    }
    return false;
}
exports.addRandom = addRandom;
function clear() {
    var obj = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    for (var j = 0; j < obj.height; j++) {
        for (var i = 0; i < obj.width; i++) {
            var t = voyageStarmaps_sidecar_1.voyageStarmaps.getTileUnsafe(obj, i, j);
            // t.isRevealed = false
            // t.isVisited = false
            // t.location = null
            voyageStarmapTiles_sidecar_1.voyageStarmapTiles.setScanned(t, false);
            voyageStarmapTiles_sidecar_1.voyageStarmapTiles.setVisited(t, false);
            voyageStarmapTiles_sidecar_1.voyageStarmapTiles.setLocation(t, null);
        }
    }
}
exports.clear = clear;
function reveal(obj, si, sj) {
    var scannerSize = 4;
    var scannerSize2 = 4.5;
    var scannerSize2Sq = Math.pow(scannerSize2, 2);
    // let std = voyageStarmapTileData.getStandard()
    for (var j = sj - scannerSize; j < sj + scannerSize + 1; j++) {
        for (var i = si - scannerSize; i < si + scannerSize + 1; i++) {
            if (distanceUtil_sidecar_1.distanceUtil.distanceSquared(si, sj, i, j) < scannerSize2Sq) {
                var t = voyageStarmaps_sidecar_1.voyageStarmaps.getTile(obj, i, j);
                if (t) {
                    if (!t.isRevealed) {
                        // voyageStarmapTiles.setBack(t, std.scanned)
                        // voyageStarmapTiles.setLocation(t, t.dataLocationHidden)
                        // t.isRevealed = true
                        voyageStarmapTiles_sidecar_1.voyageStarmapTiles.setScanned(t, true);
                    }
                }
            }
        }
    }
}
exports.reveal = reveal;
function requestTravelTo(i, j, instant) {
    var obj = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    var tNext = voyageStarmaps_sidecar_1.voyageStarmaps.getTileUnsafe(obj, i, j);
    var name = tNext.location ? tNext.location.text : 'Empty space';
    var type = tNext.location ? tNext.location.mission : voyageMissionData_1.EVoyageMissionType.Null;
    voyageMessageJump_sidecar_1.voyageMessageJump.sendMessageRequest({
        command: voyageMessageJump_1.EJumpCommand.Request,
        i: i,
        j: j,
        locationName: name,
        missionType: type,
    });
}
exports.requestTravelTo = requestTravelTo;
function travelTowards(i, j) {
    var obj = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    // let tNext = voyageStarmaps.getTileUnsafe(obj, i, j)
    // TODO: update cursor?
    obj.currentI = i;
    obj.currentJ = j;
}
exports.travelTowards = travelTowards;
function travelTo(i, j, instant) {
    var obj = voyageStarmaps_sidecar_1.voyageStarmaps.get();
    // let tOrig = voyageStarmaps.getTile(obj, obj.ci, obj.cj)
    // if (tOrig && tOrig.imageLocation) {
    //   tOrig.imageLocation.visible = true
    // }
    // let std = voyageStarmapTileData.getStandard()
    obj.currentI = i;
    obj.currentJ = j;
    obj.targetI = i;
    obj.targetJ = j;
    reveal(obj, obj.currentI, obj.currentJ);
    var tNext = voyageStarmaps_sidecar_1.voyageStarmaps.getTileUnsafe(obj, i, j);
    tNext.isVisited = true;
    //if (status.jumpCharge >= 98) {
    var name = tNext.location ? tNext.location.text : 'Empty space';
    var type = tNext.location ? tNext.location.mission : voyageMissionData_1.EVoyageMissionType.Null;
    // setOpen(false)
    // } else {
    //   voyageSounds.playFailure()
    // }
    // let hasBackgroundAsteroids = tNext.hasBackgroundAsteroids
    // voyageStarmapTiles.setLocation(tNext, std.visited)
    // if (tNext.imageLocation) {
    //   tNext.imageLocation.visible = false
    // }
    // warper.warp(instant, () => {
    //   starfield.reset()
    //   // only if in asteroid field
    //   asteroidfield.reset(hasBackgroundAsteroids)
    //   tileMapEditor.setRegionName(`Sector ${tNext.i}-${tNext.j}`)
    //   if (tNext.dataLocationHidden) {
    //     if (tNext.dataLocationHidden === std.asteroidOre) {
    //       generatorAsteroids.generateBigAsteroid(30, 10, 8, 0, 'ore')
    //     }
    //     if (tNext.dataLocationHidden === std.asteroidIce) {
    //       generatorAsteroids.generateBigAsteroid(30, 10, 8, 0, 'ice')
    //     }
    //     if (tNext.dataLocationHidden === std.asteroidMetal) {
    //       generatorAsteroids.generateBigAsteroid(30, 10, 6, 0, 'steel')
    //     }
    //     if (tNext.dataLocationHidden === std.asteroidCarbon) {
    //       generatorAsteroids.generateBigAsteroid(30, 10, 5, 0, 'carbon')
    //     }
    //     if (tNext.dataLocationHidden === std.asteroidUranium) {
    //       generatorAsteroids.generateBigAsteroid(30, 10, 4, 0, 'uranium')
    //     }
    //     if (tNext.dataLocationHidden === std.wreck) {
    //       testRig_escapeShuttle.createTestRig_escapeShuttle(30, 10, true)
    //     }
    //   }
    // })
}
exports.travelTo = travelTo;
